import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import axios from "axios";
import { Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { BACKEND_URL_PORTAIL } from "../config/const.js";

const AccessProtectedRoute = ({ children, idGroup, requiredRoles }) => {
  const [hasAccess, setHasAccess] = useState(null);
  const { t } = useTranslation();


  const { userId: idUser } = useParams();
  const { groupId:idGroupSelected } = useParams();
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const realIdGroup = idGroup || localStorage.getItem("currentOrg"); // 👈 Correction ici
  
        const response = await axios.get(
          `${BACKEND_URL_PORTAIL}api/permissions/${realIdGroup}`,
          config
        );
        const roles = response;
  
        const hasRequiredRole = roles.some((role) =>
          requiredRoles.includes(role)
        );
  
        if (hasRequiredRole) {
          if (idGroupSelected) {
            const accessResponse = await axios.get(
              `${BACKEND_URL_PORTAIL}api/checkAccessGroup/${idGroupSelected}`,
              config
            );
            setHasAccess(accessResponse.data == false ? accessResponse.data : accessResponse);
          } else if (idUser) {
            const accessResponse = await axios.get(
              `${BACKEND_URL_PORTAIL}api/checkAccessUser/${idUser}/${realIdGroup}`, 
              config
            );
            setHasAccess(accessResponse.data == false ? accessResponse.data : accessResponse);
          } else {
            setHasAccess(true);
          }
        } else {
          setHasAccess(false);
        }
      } catch (error) {
        console.error("Erreur lors de la vérification des permissions :", error);
        setHasAccess(false);
      }
    };
  
    checkAccess();
  }, [idGroup, idGroupSelected, idUser, requiredRoles]);
  

  if (hasAccess === null)
    return (
      <div className="text-center mt-6">
        <Spinner color="primary" style={{ height: "3rem", width: "3rem" }}>
          Loading...
        </Spinner>
        <div className="text-center mt-2">{t("loading...")}</div>
      </div>
    );

  if (!hasAccess) return <Navigate to="/" />;

  return children;
};

export default AccessProtectedRoute;
